import { Link } from "react-router-dom";

const CompanySection: React.FC = () => (
  <section className="py-20 bg-gray-50">
    <div className="max-w-7xl mx-auto px-4 md:px-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* Images grid */}
        <div className="grid grid-cols-2 gap-3">
          <div className="col-span-2 rounded-xl overflow-hidden h-56">
            <img
              src="https://public.readdy.ai/ai/img_res/b5ad0e90c8f4ea6cbf4f672cb3ea47b2.jpg"
              alt="STRAY LOFT LLC Store"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="rounded-xl overflow-hidden h-40">
            <img
              src="https://readdy.ai/api/search-image?query=professional%20contractor%20using%20power%20drill%20construction%20site%20Phoenix%20Arizona%20skilled%20tradesman%20at%20work&width=400&height=320&seq=company002&orientation=portrait"
              alt="Professional Contractor"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="rounded-xl overflow-hidden h-40">
            <img
              src="https://readdy.ai/api/search-image?query=hardware%20tools%20quality%20inspection%20professional%20warehouse%20organized%20inventory%20management&width=400&height=320&seq=company003&orientation=portrait"
              alt="Quality Tools"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        {/* Content */}
        <div>
          <p className="text-orange-500 text-sm font-semibold uppercase tracking-widest mb-3">About STRAY LOFT LLC</p>
          <h2 className="text-4xl font-black text-gray-900 mb-4 leading-tight">
            Phoenix&apos;s Trusted Hardware Partner
          </h2>
          <p className="text-gray-600 leading-relaxed mb-6">
            Based in Phoenix, AZ, STRAY LOFT LLC is dedicated to supplying professional-grade hardware tools to contractors, tradespeople, and serious DIY enthusiasts across the country. We carefully curate every product in our catalog to ensure it meets the demands of real job sites.
          </p>
          <p className="text-gray-600 leading-relaxed mb-8">
            From compact hand tools to heavy-duty power equipment, our selection spans $50–$1,000 to fit every budget and project scope. We partner with industry-leading brands like DeWalt, Milwaukee, Bosch, Makita, and more.
          </p>

          <div className="grid grid-cols-3 gap-4 mb-8">
            {[
              { value: "30+", label: "Products" },
              { value: "4.8★", label: "Avg Rating" },
              { value: "100%", label: "Authentic" },
            ].map((stat) => (
              <div key={stat.label} className="text-center p-4 bg-white rounded-xl border border-gray-100">
                <div className="text-2xl font-black text-orange-500">{stat.value}</div>
                <div className="text-gray-500 text-xs mt-1">{stat.label}</div>
              </div>
            ))}
          </div>

          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 bg-gray-900 text-white font-semibold rounded-lg hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            Learn More About Us <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default CompanySection;
